import React from 'react';
import '../styles/Title.scss';

export default function Title() {
  return (
    <div>
      <h3>ToDo's</h3>
      <p>Things I need to do:</p>
    </div>
  );
}
